import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"
import "slim-select/styles"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    // SlimSelect snapshots select.className onto its container; Bootstrap's
    // .form-select caret would then render next to SlimSelect's own arrow.
    this.selectTarget.classList.remove("form-select")
    this.slimSelect = new SlimSelect({
      select: this.selectTarget,
      settings: {
        closeOnSelect: false,
        placeholderText: "Choose websites",
        searchPlaceholder: "Search websites",
        searchText: "No websites found",
      },
    })
  }

  disconnect() {
    this.slimSelect?.destroy()
  }
}
